import { type LastSeenOption, type OptionDto } from "../../../../autogen/bff-api";

export const toLastSeen = (option: OptionDto): LastSeenOption => ({
  name: option.name,
  description: option.description,
  startDate: option.startDate,
  deadline: option.deadline,
  endDate: option.endDate,
  duration: option.duration,
  extension: option.extension,
  datesSetByHand: option.datesSetByHand,
});
